module.exports = __webpack_public_path__ + "static/img/icon@2x.9474213.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/activity/ktbConsociation/icon@2x.png
// module id = zzAx
// module chunks = 70